import * as yup from 'yup';

export const CreateCourseSubjectFormValidation = yup.object().shape({
    idCourse: yup.string().required('O ID do curso é obrigatório'),
    isCore: yup.boolean().required('O campo "é núcleo" é obrigatório'),
    hasExam: yup.boolean().required('O campo "tem exame" é obrigatório'),
    semester: yup.number().typeError('O semestre deve ser um número')
        .required('O semestre é obrigatório')
        .positive('O semestre deve ser maior que zero'),
    level: yup.number().required('O nível do curso é obrigatório'),
    subjects: yup.array().of(yup.string().required('O campo "disciplina" é obrigatório')).required(),
});
export const CreateCourseSubjectFormValidationAuxV2 = yup.object().shape({
    idCourse: yup.string().optional().nullable(), // Campo opcional
    idScientificArea: yup.string().required('O ID da área é obrigatório'),
    idSubject: yup.string().required('O ID da disciplina é obrigatório'),
    isCore: yup.boolean().required('O campo "é núcleo" é obrigatório'),
    hasExam: yup.boolean().required('O campo "tem exame" é obrigatório'),
    semester: yup.number().typeError('O semestre deve ser um número')
      .required('O semestre é obrigatório')
      .positive('O semestre deve ser maior que zero'),
    level: yup.number().required('O nível do curso é obrigatório'),
    credits: yup.number().typeError("Numerico").required(),
  });
  

  export const CreateCourseSubjectFormValidationV2 = yup.object().shape({
    idFaculty: yup.string().required('Unidade orgânica é obrigatória'),
    idDepartament: yup.string().required('Departamento é obrigatório'),
    idCourse: yup.string().required('Curso é obrigatório'),
    courseSubjects: yup.array().of(CreateCourseSubjectFormValidationAuxV2).required('At least one subject is required'),
  });
